import React from 'react';
import { motion } from 'framer-motion';
import { X, Zap, Eye, Clock, Crown } from 'lucide-react';
interface BoostModalProps {
  onClose: () => void;
}
export function BoostModal({
  onClose
}: BoostModalProps) {
  const boostOptions = [{
    duration: '30 min',
    price: '$4.99',
    popular: false
  }, {
    duration: '3 hours',
    price: '$9.99',
    popular: true
  }, {
    duration: '24 hours',
    price: '$19.99',
    popular: false
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="absolute inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-6" onClick={onClose} data-id="element-38">
      <motion.div initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.9,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="bg-white rounded-3xl p-6 w-full max-w-sm shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-39">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-4 right-4 p-2 hover:bg-zinc-100 rounded-full transition-colors" data-id="element-40">
          <X size={20} className="text-zinc-400" data-id="element-41" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4" data-id="element-42">
          <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-full flex items-center justify-center shadow-lg shadow-purple-500/30" data-id="element-43">
            <Zap size={40} className="text-white" fill="currentColor" data-id="element-44" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-black text-center text-zinc-900 mb-2" data-id="element-45">
          Boost Your Profile
        </h2>
        <p className="text-center text-zinc-500 mb-6" data-id="element-46">
          Be a top profile in your area and get more matches!
        </p>

        {/* Stats */}
        <div className="flex justify-center gap-6 mb-6" data-id="element-47">
          <div className="text-center" data-id="element-48">
            <div className="flex items-center justify-center gap-1 text-purple-500 mb-1" data-id="element-49">
              <Eye size={18} data-id="element-50" />
              <span className="font-bold" data-id="element-51">10x</span>
            </div>
            <p className="text-xs text-zinc-500" data-id="element-52">More views</p>
          </div>
          <div className="text-center" data-id="element-53">
            <div className="flex items-center justify-center gap-1 text-purple-500 mb-1" data-id="element-54">
              <Clock size={18} data-id="element-55" />
              <span className="font-bold" data-id="element-56">Skip</span>
            </div>
            <p className="text-xs text-zinc-500" data-id="element-57">The queue</p>
          </div>
          <div className="text-center" data-id="element-58">
            <div className="flex items-center justify-center gap-1 text-purple-500 mb-1" data-id="element-59">
              <Crown size={18} data-id="element-60" />
              <span className="font-bold" data-id="element-61">Top</span>
            </div>
            <p className="text-xs text-zinc-500" data-id="element-62">Priority</p>
          </div>
        </div>

        {/* Options */}
        <div className="space-y-3 mb-6" data-id="element-63">
          {boostOptions.map((option, index) => <button key={index} className={`w-full p-4 rounded-2xl border-2 flex items-center justify-between transition-all ${option.popular ? 'border-purple-500 bg-purple-50' : 'border-zinc-200 hover:border-zinc-300'}`} data-id="element-64">
              <div className="flex items-center gap-3" data-id="element-65">
                <Zap size={20} className={option.popular ? 'text-purple-500' : 'text-zinc-400'} data-id="element-66" />
                <span className="font-semibold text-zinc-900" data-id="element-67">
                  {option.duration}
                </span>
                {option.popular && <span className="px-2 py-0.5 bg-purple-500 text-white text-[10px] font-bold rounded-full uppercase" data-id="element-68">
                    Popular
                  </span>}
              </div>
              <span className="font-bold text-zinc-900" data-id="element-69">{option.price}</span>
            </button>)}
        </div>

        {/* CTA */}
        <button className="w-full py-4 bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-2xl font-bold text-lg shadow-lg shadow-purple-500/30 hover:shadow-xl hover:shadow-purple-500/40 transition-shadow" data-id="element-70">
          Boost Now
        </button>
      </motion.div>
    </motion.div>;
}